import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../../shared/constants/microfrontend';
import { IApplicationContext } from '../../../shared/types/application';

const DEGRADATION_TELEMETRY_KEY = 'degradation.adBannerMicrofrontendRegistry';

/**
 * Регистрирует манифест микрофронтенда рекламного баннера в браузерном реестре —
 * один раз на страницу, на бутстрапе, как это делается на ноде для остальных микрофронтендов.
 * Мест под баннер на странице может быть несколько, реестр от этого не зависит.
 *
 * На сервере этот манифест намеренно не регистрируется (см. `fetchAdBannerMicrofrontendManifest`):
 * `writeMicrofrontendsRegistry` вылил бы 514 КБ JS и 159 КБ CSS в <head>, хотя баннер не
 * рендерится на SSR. Сама регистрация ассеты не грузит — это только запись в реестр;
 * JS и CSS подтягивает `<cian-mf-ui>` в `connectedCallback`, то есть когда баннер реально
 * монтируется, а это происходит после `window.load` (см. `useAdBannerMicrofrontend`).
 *
 * Манифеста нет (фича-флаг выключен или сервис деградировал) — тихо выходим,
 * хост рендерит легаси-баннер.
 */
export function registerAdBannerMicrofrontend({
  config,
  logger,
  telemetry,
  microfrontendsRegistry,
}: IApplicationContext): void {
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  if (!manifest) {
    return;
  }

  try {
    microfrontendsRegistry.register(manifest);
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(ex, {
      degradation: 'Регистрация микрофронтенда рекламного баннера в браузерном реестре',
    });
  }
}
